<template>
  <div class="wrap next-coaching-wrap">
    <div class="top-header">
      <h3>my 코칭</h3>
    </div>
    <div class="body-wrap">
      <div class="my-coaching-menu">
        <incMenu></incMenu>
      </div>
      <div class="shot-calendar">
        <select @change="dateSetting($event, '')" v-model="toMonth">
          <option v-for="(month, index) in monthList" :key="index" :value="month.value">{{ month.text }}</option>
        </select>

        <div class="clear date-wrap">
          <VueSlickCarousel v-bind="settings" v-if="dayList.length" ref="carousel">
            <div
              class="date"
              :class="{ active: item.isToday }"
              v-for="(item, index) in dayList"
              :key="index"
              @click="selectDay(item)"
            >
              <p>{{ item.week }}</p>
              <p>{{ item.days }}</p>
              <div class="circle" v-if="item.isCoaching"></div>
              <div class="bar" v-if="currentDay == item.value"></div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
      <div class="coaching-list">
        <div v-if="!isList">
          <p class="txt-center">등록된 일정이 없습니다</p>
        </div>
        <div v-else>
          <div class="coaching" v-for="(item, index) in nextCoarching" :key="index">
            <p>{{ item[0].startDate }}</p>
            <ul>
              <li
                class="clear default"
                :class="{ disable: item.sessionStatus == 7 }"
                @click="view(subItem.sessionIdx)"
                v-for="(subItem, subIndex) in item"
                :key="subIndex"
              >
                <div>
                  <span>{{ subItem.sessionType }}</span>
                </div>
                <div class="clear">
                  <div class="w-50per float-left">
                    <h1>{{ subItem.userName }}</h1>
                  </div>
                  <div class="w-50per float-left">
                    <p>
                      {{ subItem.startTime }}~{{ subItem.endTime }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ subItem.currentSession }}/{{
                        subItem.totalSession
                      }}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { groupBy } from "@/utils/common";
// import { groupBy } from "@/utils/common.js"
export default {
  name: "next_coaching",
  data: () => ({
    toMonth: "",
    monthList: [],
    dayList: [],
    weeks: ["일", "월", "화", "수", "목", "금", "토"],
    lastDays: dayjs().daysInMonth(),
    settings: {
      arrows: false,
      dots: false,
      centerMode: false,
      centerPadding: "0px",
      focusOnSelect: true,
      infinite: false,
      slidesToShow: 7,
      speed: 100,
      swipeToSlide: true,
    },
    toDay: "",
    nextCoarching: [],
    originCoarching: [],
    currentDay: "",
    coarIdx: 0,
    isList: false,
    monthScheduleList: [],
    isLoading: false,
  }),
  components: {
    VueSlickCarousel,
    incMenu,
    incTab,
  },
  mounted() {
    this.coarIdx = this.$store.state.userInfo.idxTbCoarch;
    dayjs.locale("ko");
    this.toMonth = dayjs().format("YYYY-MM");
    this.toDay = dayjs().format("YYYY-MM-DD");
    for (let i = 1; i <= 12; i++) {
      let item = {
        value: i < 10 ? dayjs().format("YYYY-") + "0" + i : dayjs().format("YYYY-") + i,
        text: dayjs().format("YYYY년") + " " + i + "월",
      };
      this.monthList.push(item);
    }
    this.dateSetting("", dayjs().format("YYYY-MM"));
  },
  methods: {
    showNext() {
      this.$refs.carousel && this.$refs.carousel.goTo(0);
    },
    selectDay(item) {
      this.currentDay = item.value;
      let targetDate = dayjs(item.value).format("YYYY-MM-DD");
      this.getNextCoarching(targetDate);
    },
    getNextCoarching(targetDate) {
      this.axios
        .get(`/front/coarch/${this.coarIdx}/schedule/month/${targetDate}`)
        .then((res) => {
          if (res.data.success) {
            // let temp = res.data.contentinfo.monthScheduleList;
            this.monthScheduleList = res.data.contentinfo.monthScheduleList;
            if (this.monthScheduleList.length) {
              this.isList = true;
            } else {
              this.isList = false;
            }
            for (let item of this.monthScheduleList) {
              item.startDate = dayjs(item.startDatetime).format("YYYY-MM-DD");
              item.startTime = dayjs(item.startDatetime).format("HH:mm");
              item.endTime = dayjs(item.endDatetime).format("HH:mm");
            }
            // this.coarchingCheck(targetDate);
            for (let i = 0; i < this.dayList.length; i++) {
              for (let j = 0; j < this.monthScheduleList.length; j++) {
                if (this.dayList[i].value == this.monthScheduleList[j].startDate) {
                  this.dayList[i].isCoaching = true;
                }
              }
            }
            this.nextCoarching = groupBy(this.monthScheduleList, "startDate");
            if (targetDate == dayjs().format("YYYY-MM")) {
              this.$refs.carousel.goTo(dayjs(this.toDay).get("date") - 2);
            }
            // else{
            //     alert("abc");
            //     this.$refs.carousel.goTo(0);
            // }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dateSetting(event, today) {
      this.dayList = [];
      let targetMonth = "";
      if (event == "") {
        targetMonth = dayjs(today);
      } else {
        targetMonth = dayjs(event.target.value);
      }
      this.lastDays = targetMonth.daysInMonth();

      for (let i = 1; i <= this.lastDays; i++) {
        let format = "";
        let days = "";
        if (i < 10) {
          days = "0" + i;
        } else {
          days = "" + i + "";
        }
        format = targetMonth.format("YYYY") + "-" + targetMonth.format("MM") + "-" + days;

        let date = dayjs(format);
        let item = {
          value: format,
          week: this.weeks[date.format("d")],
          days: days,
          isToday: false,
          isCoaching: false,
        };
        if (format == this.toDay) {
          item.isToday = true;
        }
        this.dayList.push(item);
      }
      this.getNextCoarching(this.toMonth);
      this.showNext();
    },

    view(sessionIdx) {
      this.$router.push({ name: "reservation_coaching_view", params: { sessionIdx: sessionIdx } });
    },
  },
};
</script>
7
